export class ClassType {
  public constructor() {
    this.ClassTypeId = -1;
    this.ClassType = '';
    this.Descr = '';
  }

  public ClassTypeId: number;
  public ClassType: string;
  public Descr: string;
}
